/*import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../storage-service/storage.service'; 
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MotoristaJornadaDTO } from '../../models/motoristaJornadaDTO';

@Injectable({
  providedIn: 'root'
})
export class MotoristaJornadaService {

  private apiUrl: string = '';
  private storageService = inject(StorageService);

  constructor(private http: HttpClient) {}

  // Inicializa a URL da API
  private async initApiUrl(): Promise<string> {
    if (this.apiUrl) return this.apiUrl; // já inicializado

    try {
      const servidor = await this.storageService.getServidor();
      if (servidor && servidor.url_servidor) {
        this.apiUrl = `${servidor.url_servidor}/motorista-jornada`;
      } else {
        this.apiUrl = 'https://i9fluir.com.br:8082/api/motorista-jornada';
      }
    } catch (error) {
      console.error('Erro ao buscar a URL da API:', error);
      this.apiUrl = 'https://i9fluir.com.br:8082/api/motorista-jornada';
    }

    return this.apiUrl;
  }

  getUrlServidor(): string {
    return this.apiUrl;
  }

  listarMotoristas(): Observable<MotoristaJornadaDTO[]> {
    return from(this.initApiUrl()).pipe(
      switchMap(url => this.http.get<MotoristaJornadaDTO[]>(`${url}/motoristas`))
    );
  }

  buscarPorMatricula(matricula: number): Observable<MotoristaJornadaDTO> {
    return from(this.initApiUrl()).pipe(
      switchMap(url => this.http.get<MotoristaJornadaDTO>(`${url}/motorista/${matricula}`))
    );
  }

  iniciarOuFinalizar(idFolhaServico: number, tipo: 'iniciar' | 'finalizar', token: string): Observable<any> {
  // Apenas simulação: mostra no console os dados e o token
  console.log('Ação:', tipo);
  console.log('ID Folha de Serviço:', idFolhaServico);
  console.log('Token JWT recebido:', token);

  // Retorna um Observable "fake" para manter compatibilidade com subscribe()
  return new Observable(observer => {
    observer.next({ message: `Simulação de ${tipo} concluída` });
    observer.complete();
  });
}

}*/

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MotoristaJornadaDTO } from '../../models/motoristaJornadaDTO';

@Injectable({
  providedIn: 'root'
})
export class MotoristaJornadaService {

  constructor(private http: HttpClient) {}

  listarMotoristas(): Observable<MotoristaJornadaDTO[]> {
    return this.http.get<MotoristaJornadaDTO[]>(
      `/motorista-jornada/motoristas`
    );
  }

  buscarPorMatricula(matricula: number): Observable<MotoristaJornadaDTO> {
    return this.http.get<MotoristaJornadaDTO>(
      `/motorista-jornada/motorista/${matricula}`
    );
  }

  iniciarOuFinalizar(
    idFolhaServico: number,
    tipo: 'iniciar' | 'finalizar',
    token: string
  ): Observable<any> {

    const body = { idFolhaServico };

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.post(
      `/motorista-jornada/${tipo}`,
      body,
      { headers }
    );
  }
}